/**
 * Accounts API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccountDetailDto
 */
export interface AccountDetailDto {
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccountDetailDto
     */
    eisFlag?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    groupNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    servicingAgents?: String [];
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    agentOfRecordNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof AccountDetailDto
     */
    lastAppSubmittedDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AccountDetailDto
     */
    accountEffectiveDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AccountDetailDto
     */
    accountTerminationDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    terminationCodeDesc?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    contact?: string;
    /**
     * 
     * @type {Date}
     * @memberof AccountDetailDto
     */
    lastPaymentDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof AccountDetailDto
     */
    eDelivery?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AccountDetailDto
     */
    annualizedPremium?: number;
    /**
     * 
     * @type {Address}
     * @memberof AccountDetailDto
     */
    address?: Address;
    /**
     * 
     * @type {PendingPaymentDto}
     * @memberof AccountDetailDto
     */
    pendingPayment?: PendingPaymentDto;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    accountTeam?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    paymentFrequency?: string;
    /**
     * 
     * @type {Array<InvoiceDto>}
     * @memberof AccountDetailDto
     */
    invoices?: Array<InvoiceDto>;
    /**
     * 
     * @type {Array<PaymentDto>}
     * @memberof AccountDetailDto
     */
    payments?: Array<PaymentDto>;
    /**
     * 
     * @type {Array<CommissionAgentDto>}
     * @memberof AccountDetailDto
     */
    commissionAgents?: Array<CommissionAgentDto>;
    /**
     * 
     * @type {string}
     * @memberof AccountDetailDto
     */
    status?: string;
    /**
     * 
     * @type {Source}
     * @memberof AccountDetailDto
     */
    source?: Source;
}
/**
 * 
 * @export
 * @interface AccountDto
 */
export interface AccountDto {
    /**
     * 
     * @type {string}
     * @memberof AccountDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDto
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDto
     */
    groupNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDto
     */
    servicingAgentNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDto
     */
    agentOfRecordNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof AccountDto
     */
    lastAppSubmittedDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof AccountDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountDto
     */
    annualizedPremium?: number;
    /**
     * 
     * @type {Source}
     * @memberof AccountDto
     */
    source?: Source;
    /**
     * 
     * @type {Array<AccountPaymentStatus>}
     * @memberof AccountDto
     */
    paymentStatus?: Array<AccountPaymentStatus>;
    /**
     * 
     * @type {Array<Link>}
     * @memberof AccountDto
     */
    links?: Array<Link>;
    /**
     * 
     * @type {string}
     * @memberof AccountDto
     */
    customerUri?: string;
}
/**
 * 
 * @export
 * @interface AccountPaymentStatus
 */
export interface AccountPaymentStatus extends Enumeration {
}
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    fullAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    line3?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    zipCode?: string;
}
/**
 * 
 * @export
 * @interface AddressAllOf
 */
export interface AddressAllOf {
    /**
     * 
     * @type {string}
     * @memberof AddressAllOf
     */
    fullAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressAllOf
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressAllOf
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressAllOf
     */
    line3?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressAllOf
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressAllOf
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressAllOf
     */
    zipCode?: string;
}
/**
 * 
 * @export
 * @interface AgentDto
 */
export interface AgentDto {
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface CommissionAgentDto
 */
export interface CommissionAgentDto extends AgentDto {
}
/**
 * 
 * @export
 * @interface DiscrepancyDto
 */
export interface DiscrepancyDto {
    /**
     * 
     * @type {string}
     * @memberof DiscrepancyDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscrepancyDto
     */
    policyNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscrepancyDto
     */
    policyType?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscrepancyDto
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof DiscrepancyDto
     */
    issueDate: Date;
    /**
     * 
     * @type {number}
     * @memberof DiscrepancyDto
     */
    billAmount: number;
    /**
     * 
     * @type {number}
     * @memberof DiscrepancyDto
     */
    paidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof DiscrepancyDto
     */
    discrepancyAmount: number;
}
/**
 * 
 * @export
 * @interface DiscrepancySummaryDto
 */
export interface DiscrepancySummaryDto {
    /**
     * 
     * @type {string}
     * @memberof DiscrepancySummaryDto
     */
    last4PayorNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscrepancySummaryDto
     */
    payorName?: string;
    /**
     * 
     * @type {Date}
     * @memberof DiscrepancySummaryDto
     */
    paymentDate: Date;
    /**
     * 
     * @type {number}
     * @memberof DiscrepancySummaryDto
     */
    billAmount: number;
    /**
     * 
     * @type {number}
     * @memberof DiscrepancySummaryDto
     */
    paidAmount: number;
    /**
     * 
     * @type {number}
     * @memberof DiscrepancySummaryDto
     */
    discrepancyAmount: number;
    /**
     * 
     * @type {Array<DiscrepancyDto>}
     * @memberof DiscrepancySummaryDto
     */
    discrepancies?: Array<DiscrepancyDto>;
}
/**
 * 
 * @export
 * @interface Enumeration
 */
export interface Enumeration {
    /**
     * 
     * @type {string}
     * @memberof Enumeration
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof Enumeration
     */
    id: number;
}
/**
 * 
 * @export
 * @interface ImageDto
 */
export interface ImageDto {
    /**
     * 
     * @type {string}
     * @memberof ImageDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageDto
     */
    documentKey?: string;
    /**
     * 
     * @type {Date}
     * @memberof ImageDto
     */
    createDate?: Date;
    /**
     * 
     * @type {Array<Link>}
     * @memberof ImageDto
     */
    links?: Array<Link>;
}
/**
 * 
 * @export
 * @interface ImageSearchResponseDto
 */
export interface ImageSearchResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ImageSearchResponseDto
     */
    status?: string;
    /**
     * 
     * @type {Array<ImageDto>}
     * @memberof ImageSearchResponseDto
     */
    images?: Array<ImageDto>;
}
/**
 * 
 * @export
 * @interface InvoiceDto
 */
export interface InvoiceDto {
    /**
     * 
     * @type {Date}
     * @memberof InvoiceDto
     */
    invoiceDate: Date;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceDto
     */
    isDelinquent: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    documentId?: string;
    /**
     * 
     * @type {Link}
     * @memberof InvoiceDto
     */
    link?: Link;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    invoiceNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceDto
     */
    hasDiscrepancies?: boolean;
     /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
     status?: string;
     /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    externalUrl: string | null;
}
/**
 * 
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    href?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    rel?: string;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    verb?: string;
}
/**
 * 
 * @export
 * @interface PagedResultOfAccountDto
 */
export interface PagedResultOfAccountDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfAccountDto
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfAccountDto
     */
    currentPageNumber: number;
    /**
     * 
     * @type {Array<AccountDto>}
     * @memberof PagedResultOfAccountDto
     */
    result?: Array<AccountDto>;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfAccountDto
     */
    links?: Array<Link>;
}
/**
 * 
 * @export
 * @interface PaymentDto
 */
export interface PaymentDto {
    /**
     * 
     * @type {Date}
     * @memberof PaymentDto
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof PaymentDto
     */
    amount: number;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentDto
     */
    hasDiscrepancies: boolean;
     /**
     * 
     * @type {string}
     * @memberof PaymentDto
     */
     paymentNumber?: string;
}
/**
 * 
 * @export
 * @interface PendingPaymentDto
 */
export interface PendingPaymentDto {
    /**
     * 
     * @type {Date}
     * @memberof PendingPaymentDto
     */
    processDate: Date;
    /**
     * 
     * @type {string}
     * @memberof PendingPaymentDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingPaymentDto
     */
    statusDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingPaymentDto
     */
    workType?: string;
}
/**
 * 
 * @export
 * @interface ProcessLogDto
 */
export interface ProcessLogDto {
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    processName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    machineName?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProcessLogDto
     */
    etlLoadStartDateTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProcessLogDto
     */
    etlLoadEndDateTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    elapsedTime?: string;
}
/**
 * 
 * @export
 * @interface ReportRequestDto
 */
export interface ReportRequestDto {
    /**
     * 
     * @type {number}
     * @memberof ReportRequestDto
     */
    reportId: number;
    /**
     * 
     * @type {string}
     * @memberof ReportRequestDto
     */
    fileGUID?: string;
    /**
     * 
     * @type {Date}
     * @memberof ReportRequestDto
     */
    requestDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ReportRequestDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportRequestDto
     */
    accountNumber?: string;
    /**
     * 
     * @type {Link}
     * @memberof ReportRequestDto
     */
    link?: Link;
    /**
     * 
     * @type {boolean}
     * @memberof ReportRequestDto
     */
     eisFlag: boolean | null;
}   
/**
 * 
 * @export
 * @interface RequestDetails
 */
export interface RequestDetails {
    /**
     * 
     * @type {string}
     * @memberof RequestDetails
     */
    accountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestDetails
     */
    portalUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestDetails
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestDetails
     */
    sourceId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RequestDetails
     */
     eisFlag?: boolean;
}
/**
 * 
 * @export
 * @interface RequestRemoveDetails
 */
export interface RequestRemoveDetails {
    /**
     * 
     * @type {string}
     * @memberof RequestRemoveDetails
     */
    portalUserId?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestRemoveDetails
     */
    reportId: number;
    /**
     * 
     * @type {boolean}
     * @memberof RequestRemoveDetails
     */
     eisFlag: boolean | null;
}
/**
 * 
 * @export
 * @interface Source
 */
export interface Source extends Enumeration {
}

/**
 * AccountsApi - axios parameter creator
 * @export
 */
export const AccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {number} [sourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsAccountETL(version: string, sourceId?: number, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling accountsAccountETL.');
            }
            const localVarPath = `/api/employer/v{version}/accounts/etl`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (sourceId !== undefined) {
                localVarQueryParameter['sourceId'] = sourceId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsAccountETLReset(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling accountsAccountETLReset.');
            }
            const localVarPath = `/api/employer/v{version}/accounts/etl/reset`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsGet(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling accountsGet.');
            }
            
            const localVarPath = `/api/employer/v{version}/accounts`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
        
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsGetCsv(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling accountsGetCsv.');
            }
            const localVarPath = `/api/employer/v{version}/accounts/csv`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsPrepareAccountsForEtlReset(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling accountsPrepareAccountsForEtlReset.');
            }
            const localVarPath = `/api/employer/v{version}/accounts/etl/setup`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountsApi - functional programming interface
 * @export
 */
export const AccountsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {number} [sourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsAccountETL(version: string, sourceId?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AccountsApiAxiosParamCreator(configuration).accountsAccountETL(version, sourceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsAccountETLReset(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AccountsApiAxiosParamCreator(configuration).accountsAccountETLReset(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsGet(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfAccountDto> {
            const localVarAxiosArgs = AccountsApiAxiosParamCreator(configuration).accountsGet(version, options);
            
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
             
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsGetCsv(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = AccountsApiAxiosParamCreator(configuration).accountsGetCsv(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsPrepareAccountsForEtlReset(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = AccountsApiAxiosParamCreator(configuration).accountsPrepareAccountsForEtlReset(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AccountsApi - factory interface
 * @export
 */
export const AccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {number} [sourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsAccountETL(version: string, sourceId?: number, options?: any): AxiosPromise<void> {
            return AccountsApiFp(configuration).accountsAccountETL(version, sourceId, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsAccountETLReset(version: string, options?: any): AxiosPromise<void> {
            return AccountsApiFp(configuration).accountsAccountETLReset(version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsGet(version: string, options?: any): AxiosPromise<PagedResultOfAccountDto> {
            return AccountsApiFp(configuration).accountsGet(version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsGetCsv(version: string, options?: any): AxiosPromise<any> {
            return AccountsApiFp(configuration).accountsGetCsv(version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountsPrepareAccountsForEtlReset(version: string, options?: any): AxiosPromise<void> {
            return AccountsApiFp(configuration).accountsPrepareAccountsForEtlReset(version, options)(axios, basePath);
        },
    };
};

/**
 * AccountsApi - object-oriented interface
 * @export
 * @class AccountsApi
 * @extends {BaseAPI}
 */
export class AccountsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {number} [sourceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public accountsAccountETL(version: string, sourceId?: number, options?: any) {
        return AccountsApiFp(this.configuration).accountsAccountETL(version, sourceId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public accountsAccountETLReset(version: string, options?: any) {
        return AccountsApiFp(this.configuration).accountsAccountETLReset(version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public accountsGet(version: string, options?: any) {
        return AccountsApiFp(this.configuration).accountsGet(version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public accountsGetCsv(version: string, options?: any) {
        return AccountsApiFp(this.configuration).accountsGetCsv(version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public accountsPrepareAccountsForEtlReset(version: string, options?: any) {
        return AccountsApiFp(this.configuration).accountsPrepareAccountsForEtlReset(version, options)(this.axios, this.basePath);
    }

}


/**
 * BillingApi - axios parameter creator
 * @export
 */
export const BillingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} accountNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGet(id: string, accountNumber: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling billingGet.');
            }
            // verify required parameter 'accountNumber' is not null or undefined
            if (accountNumber === null || accountNumber === undefined) {
                throw new RequiredError('accountNumber','Required parameter accountNumber was null or undefined when calling billingGet.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling billingGet.');
            }
            const localVarPath = `/api/employer/v{version}/accounts/billing/{id}/accountNumber/{accountNumber}/document`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"accountNumber"}}`, encodeURIComponent(String(accountNumber)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BillingApi - functional programming interface
 * @export
 */
export const BillingApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} accountNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGet(id: string, accountNumber: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = BillingApiAxiosParamCreator(configuration).billingGet(id, accountNumber, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BillingApi - factory interface
 * @export
 */
export const BillingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} accountNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingGet(id: string, accountNumber: string, version: string, options?: any): AxiosPromise<string> {
            return BillingApiFp(configuration).billingGet(id, accountNumber, version, options)(axios, basePath);
        },
    };
};

/**
 * BillingApi - object-oriented interface
 * @export
 * @class BillingApi
 * @extends {BaseAPI}
 */
export class BillingApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} accountNumber 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public billingGet(id: string, accountNumber: string, version: string, options?: any) {
        return BillingApiFp(this.configuration).billingGet(id, accountNumber, version, options)(this.axios, this.basePath);
    }

}


/**
 * DetailsApi - axios parameter creator
 * @export
 */
export const DetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} accountNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailsGet(id: string, accountNumber: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling detailsGet.');
            }
            // verify required parameter 'accountNumber' is not null or undefined
            if (accountNumber === null || accountNumber === undefined) {
                throw new RequiredError('accountNumber','Required parameter accountNumber was null or undefined when calling detailsGet.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling detailsGet.');
            }
            const localVarPath = `/api/employer/v{version}/accounts/{id}/accountNumber/{accountNumber}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"accountNumber"}}`, encodeURIComponent(String(accountNumber)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DetailsApi - functional programming interface
 * @export
 */
export const DetailsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} accountNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailsGet(id: string, accountNumber: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountDetailDto> {
            const localVarAxiosArgs = DetailsApiAxiosParamCreator(configuration).detailsGet(id, accountNumber, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DetailsApi - factory interface
 * @export
 */
export const DetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} accountNumber 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detailsGet(id: string, accountNumber: string, version: string, options?: any): AxiosPromise<AccountDetailDto> {
            return DetailsApiFp(configuration).detailsGet(id, accountNumber, version, options)(axios, basePath);
        },
    };
};

/**
 * DetailsApi - object-oriented interface
 * @export
 * @class DetailsApi
 * @extends {BaseAPI}
 */
export class DetailsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} accountNumber 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DetailsApi
     */
    public detailsGet(id: string, accountNumber: string, version: string, options?: any) {
        return DetailsApiFp(this.configuration).detailsGet(id, accountNumber, version, options)(this.axios, this.basePath);
    }

}


/**
 * DiscrepancySummariesApi - axios parameter creator
 * @export
 */
export const DiscrepancySummariesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discrepancySummariesGet(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling discrepancySummariesGet.');
            }
            const localVarPath = `/api/employer/v{version}/accounts/discrepancysummaries`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportdiscrepanciestocsv(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling exportdiscrepanciestocsv.');
            }
            const localVarPath = `/api/employer/v{version}/accounts/discrepancysummaries/csv`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiscrepancySummariesApi - functional programming interface
 * @export
 */
export const DiscrepancySummariesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discrepancySummariesGet(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscrepancySummaryDto> {
            const localVarAxiosArgs = DiscrepancySummariesApiAxiosParamCreator(configuration).discrepancySummariesGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportdiscrepanciestocsv(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any> {
            const localVarAxiosArgs = DiscrepancySummariesApiAxiosParamCreator(configuration).exportdiscrepanciestocsv(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DiscrepancySummariesApi - factory interface
 * @export
 */
export const DiscrepancySummariesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discrepancySummariesGet(version: string, options?: any): AxiosPromise<DiscrepancySummaryDto> {
            return DiscrepancySummariesApiFp(configuration).discrepancySummariesGet(version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportdiscrepanciestocsv(version: string, options?: any): AxiosPromise<any> {
            return DiscrepancySummariesApiFp(configuration).exportdiscrepanciestocsv(version, options)(axios, basePath);
        },
    };
};

/**
 * DiscrepancySummariesApi - object-oriented interface
 * @export
 * @class DiscrepancySummariesApi
 * @extends {BaseAPI}
 */
export class DiscrepancySummariesApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscrepancySummariesApi
     */
    public discrepancySummariesGet(version: string, options?: any) {
        return DiscrepancySummariesApiFp(this.configuration).discrepancySummariesGet(version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscrepancySummariesApi
     */
    public exportdiscrepanciestocsv(version: string, options?: any) {
        return DiscrepancySummariesApiFp(this.configuration).exportdiscrepanciestocsv(version, options)(this.axios, this.basePath);
    }

}


/**
 * EnrollmentApplicationApi - axios parameter creator
 * @export
 */
export const EnrollmentApplicationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {string} [accountNumber] 
         * @param {string} [agentNumber] 
         * @param {number} [enrollmentApplicationUploadTypeId] 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentApplicationUploadDocument(id: string, version: string, accountNumber?: string, agentNumber?: string, enrollmentApplicationUploadTypeId?: number, file?: any, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling enrollmentApplicationUploadDocument.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollmentApplicationUploadDocument.');
            }
            const localVarPath = `/api/employer/v{version}/accounts/{id}/enrollmentapplications/upload`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (accountNumber !== undefined) { 
                localVarFormParams.append('AccountNumber', accountNumber as any);
            }
    
            if (agentNumber !== undefined) { 
                localVarFormParams.append('AgentNumber', agentNumber as any);
            }
    
            if (enrollmentApplicationUploadTypeId !== undefined) { 
                localVarFormParams.append('EnrollmentApplicationUploadTypeId', enrollmentApplicationUploadTypeId as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnrollmentApplicationApi - functional programming interface
 * @export
 */
export const EnrollmentApplicationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {string} [accountNumber] 
         * @param {string} [agentNumber] 
         * @param {number} [enrollmentApplicationUploadTypeId] 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentApplicationUploadDocument(id: string, version: string, accountNumber?: string, agentNumber?: string, enrollmentApplicationUploadTypeId?: number, file?: any, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = EnrollmentApplicationApiAxiosParamCreator(configuration).enrollmentApplicationUploadDocument(id, version, accountNumber, agentNumber, enrollmentApplicationUploadTypeId, file, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EnrollmentApplicationApi - factory interface
 * @export
 */
export const EnrollmentApplicationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {string} [accountNumber] 
         * @param {string} [agentNumber] 
         * @param {number} [enrollmentApplicationUploadTypeId] 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentApplicationUploadDocument(id: string, version: string, accountNumber?: string, agentNumber?: string, enrollmentApplicationUploadTypeId?: number, file?: any, options?: any): AxiosPromise<string> {
            return EnrollmentApplicationApiFp(configuration).enrollmentApplicationUploadDocument(id, version, accountNumber, agentNumber, enrollmentApplicationUploadTypeId, file, options)(axios, basePath);
        },
    };
};

/**
 * EnrollmentApplicationApi - object-oriented interface
 * @export
 * @class EnrollmentApplicationApi
 * @extends {BaseAPI}
 */
export class EnrollmentApplicationApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {string} [accountNumber] 
     * @param {string} [agentNumber] 
     * @param {number} [enrollmentApplicationUploadTypeId] 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollmentApplicationApi
     */
    public enrollmentApplicationUploadDocument(id: string, version: string, accountNumber?: string, agentNumber?: string, enrollmentApplicationUploadTypeId?: number, file?: any, options?: any) {
        return EnrollmentApplicationApiFp(this.configuration).enrollmentApplicationUploadDocument(id, version, accountNumber, agentNumber, enrollmentApplicationUploadTypeId, file, options)(this.axios, this.basePath);
    }

}


/**
 * HeartbeatApi - axios parameter creator
 * @export
 */
export const HeartbeatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling heartbeatGet.');
            }
            const localVarPath = `/api/employer/v{version}/accounts/heartbeat`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HeartbeatApi - functional programming interface
 * @export
 */
export const HeartbeatApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = HeartbeatApiAxiosParamCreator(configuration).heartbeatGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * HeartbeatApi - factory interface
 * @export
 */
export const HeartbeatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet(version: string, options?: any): AxiosPromise<void> {
            return HeartbeatApiFp(configuration).heartbeatGet(version, options)(axios, basePath);
        },
    };
};

/**
 * HeartbeatApi - object-oriented interface
 * @export
 * @class HeartbeatApi
 * @extends {BaseAPI}
 */
export class HeartbeatApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HeartbeatApi
     */
    public heartbeatGet(version: string, options?: any) {
        return HeartbeatApiFp(this.configuration).heartbeatGet(version, options)(this.axios, this.basePath);
    }

}


/**
 * ImagesApi - axios parameter creator
 * @export
 */
export const ImagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} documentKey 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountImageByDocumentKey(documentKey: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'documentKey' is not null or undefined
            if (documentKey === null || documentKey === undefined) {
                throw new RequiredError('documentKey','Required parameter documentKey was null or undefined when calling getAccountImageByDocumentKey.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getAccountImageByDocumentKey.');
            }
            const localVarPath = `/api/employer/v{version}/accounts/images/{documentKey}`
                .replace(`{${"documentKey"}}`, encodeURIComponent(String(documentKey)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountImagesById(id: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getAccountImagesById.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getAccountImagesById.');
            }
            const localVarPath = `/api/employer/v{version}/accounts/{id}/images`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImagesApi - functional programming interface
 * @export
 */
export const ImagesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} documentKey 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountImageByDocumentKey(documentKey: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = ImagesApiAxiosParamCreator(configuration).getAccountImageByDocumentKey(documentKey, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountImagesById(id: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageSearchResponseDto> {
            const localVarAxiosArgs = ImagesApiAxiosParamCreator(configuration).getAccountImagesById(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ImagesApi - factory interface
 * @export
 */
export const ImagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} documentKey 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountImageByDocumentKey(documentKey: string, version: string, options?: any): AxiosPromise<string> {
            return ImagesApiFp(configuration).getAccountImageByDocumentKey(documentKey, version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountImagesById(id: string, version: string, options?: any): AxiosPromise<ImageSearchResponseDto> {
            return ImagesApiFp(configuration).getAccountImagesById(id, version, options)(axios, basePath);
        },
    };
};

/**
 * ImagesApi - object-oriented interface
 * @export
 * @class ImagesApi
 * @extends {BaseAPI}
 */
export class ImagesApi extends BaseAPI {
    /**
     * 
     * @param {string} documentKey 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    public getAccountImageByDocumentKey(documentKey: string, version: string, options?: any) {
        return ImagesApiFp(this.configuration).getAccountImageByDocumentKey(documentKey, version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImagesApi
     */
    public getAccountImagesById(id: string, version: string, options?: any) {
        return ImagesApiFp(this.configuration).getAccountImagesById(id, version, options)(this.axios, this.basePath);
    }

}


/**
 * ProcessLogsApi - axios parameter creator
 * @export
 */
export const ProcessLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEtlStatuses(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getLatestEtlStatuses.');
            }
            const localVarPath = `/api/employer/v{version}/accounts/processlogs/latest`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessLogsApi - functional programming interface
 * @export
 */
export const ProcessLogsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEtlStatuses(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessLogDto>> {
            const localVarAxiosArgs = ProcessLogsApiAxiosParamCreator(configuration).getLatestEtlStatuses(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProcessLogsApi - factory interface
 * @export
 */
export const ProcessLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEtlStatuses(version: string, options?: any): AxiosPromise<Array<ProcessLogDto>> {
            return ProcessLogsApiFp(configuration).getLatestEtlStatuses(version, options)(axios, basePath);
        },
    };
};

/**
 * ProcessLogsApi - object-oriented interface
 * @export
 * @class ProcessLogsApi
 * @extends {BaseAPI}
 */
export class ProcessLogsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessLogsApi
     */
    public getLatestEtlStatuses(version: string, options?: any) {
        return ProcessLogsApiFp(this.configuration).getLatestEtlStatuses(version, options)(this.axios, this.basePath);
    }

}


/**
 * ReportsApi - axios parameter creator
 * @export
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {boolean} [exportToCsv] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGet(id: string, version: string, exportToCsv?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling reportsGet.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling reportsGet.');
            }
            const localVarPath = `/api/employer/v{version}/accounts/reports/{id}/requests`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (exportToCsv !== undefined) {
                localVarQueryParameter['exportToCsv'] = exportToCsv;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileGuid 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGetReport(fileGuid: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'fileGuid' is not null or undefined
            if (fileGuid === null || fileGuid === undefined) {
                throw new RequiredError('fileGuid','Required parameter fileGuid was null or undefined when calling reportsGetReport.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling reportsGetReport.');
            }
            const localVarPath = `/api/employer/v{version}/accounts/reports/{fileGuid}`
                .replace(`{${"fileGuid"}}`, encodeURIComponent(String(fileGuid)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {RequestRemoveDetails} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsRemoveReport(version: string, request: RequestRemoveDetails, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling reportsRemoveReport.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new RequiredError('request','Required parameter request was null or undefined when calling reportsRemoveReport.');
            }
            const localVarPath = `/api/employer/v{version}/accounts/reports/remove`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof request !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(request !== undefined ? request : {}) : (request || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {RequestDetails} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsRequestReport(version: string, request: RequestDetails, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling reportsRequestReport.');
            }
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new RequiredError('request','Required parameter request was null or undefined when calling reportsRequestReport.');
            }
            const localVarPath = `/api/employer/v{version}/accounts/reports/request`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof request !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(request !== undefined ? request : {}) : (request || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 * @export
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {boolean} [exportToCsv] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGet(id: string, version: string, exportToCsv?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportRequestDto>> {
            const localVarAxiosArgs = ReportsApiAxiosParamCreator(configuration).reportsGet(id, version, exportToCsv, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} fileGuid 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGetReport(fileGuid: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = ReportsApiAxiosParamCreator(configuration).reportsGetReport(fileGuid, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {RequestRemoveDetails} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsRemoveReport(version: string, request: RequestRemoveDetails, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean> {
            const localVarAxiosArgs = ReportsApiAxiosParamCreator(configuration).reportsRemoveReport(version, request, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {RequestDetails} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsRequestReport(version: string, request: RequestDetails, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean> {
            const localVarAxiosArgs = ReportsApiAxiosParamCreator(configuration).reportsRequestReport(version, request, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ReportsApi - factory interface
 * @export
 */
export const ReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {boolean} [exportToCsv] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGet(id: string, version: string, exportToCsv?: boolean, options?: any): AxiosPromise<Array<ReportRequestDto>> {
            return ReportsApiFp(configuration).reportsGet(id, version, exportToCsv, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} fileGuid 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGetReport(fileGuid: string, version: string, options?: any): AxiosPromise<string> {
            return ReportsApiFp(configuration).reportsGetReport(fileGuid, version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {RequestRemoveDetails} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsRemoveReport(version: string, request: RequestRemoveDetails, options?: any): AxiosPromise<boolean> {
            return ReportsApiFp(configuration).reportsRemoveReport(version, request, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {RequestDetails} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsRequestReport(version: string, request: RequestDetails, options?: any): AxiosPromise<boolean> {
            return ReportsApiFp(configuration).reportsRequestReport(version, request, options)(axios, basePath);
        },
    };
};

/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
export class ReportsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {boolean} [exportToCsv] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsGet(id: string, version: string, exportToCsv?: boolean, options?: any) {
        return ReportsApiFp(this.configuration).reportsGet(id, version, exportToCsv, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} fileGuid 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsGetReport(fileGuid: string, version: string, options?: any) {
        return ReportsApiFp(this.configuration).reportsGetReport(fileGuid, version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {RequestRemoveDetails} request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsRemoveReport(version: string, request: RequestRemoveDetails, options?: any) {
        return ReportsApiFp(this.configuration).reportsRemoveReport(version, request, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {RequestDetails} request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public reportsRequestReport(version: string, request: RequestDetails, options?: any) {
        return ReportsApiFp(this.configuration).reportsRequestReport(version, request, options)(this.axios, this.basePath);
    }

}


